import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l.007 15.748","key":"svg-0"}]]

/**
 * IconStarHalf
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3Rhci1oYWxmIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMiAxNy43NWwtNi4xNzIgMy4yNDVsMS4xNzkgLTYuODczbC01IC00Ljg2N2w2LjkgLTFsMy4wODYgLTYuMjUzbC4wMDcgMTUuNzQ4IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/star-half
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconStarHalf = createReactComponent('outline', 'star-half', 'StarHalf', __iconNode);

export default IconStarHalf;